import { z } from "zod";
import { ProjectIdSchema } from "../primitives/ids.js";
import { SafeEditPresentationOutcomeSchema } from "../presentation/derive-safe-edit-presentation.js";
import { CanonicalPresentationModelV1Schema } from "./canonical-presentation.js";
/**
 * Studio transport envelope for the Agency half of the Slice D safe-edit presentation
 * (ENR-UX-009). Resolved server-side from the same authoritative attempt/run source as the
 * Client journey presentation, so Agency and Client can never disagree about one attempt.
 * Studio React renders this model; it must not re-derive safe-edit lifecycle.
 */
export const StudioSafeEditPresentationV1Schema = z
    .object({
    schemaId: z.literal("studio.safeEditPresentation.v1"),
    projectId: ProjectIdSchema,
    generatedAt: z.string().datetime(),
    /** True when an active safe-edit attempt owns the current project moment. */
    ownsMoment: z.boolean(),
    outcome: SafeEditPresentationOutcomeSchema.nullable(),
    presentation: CanonicalPresentationModelV1Schema.nullable(),
})
    .strict()
    .superRefine((value, ctx) => {
    const completeOwnership = value.outcome != null && value.presentation != null;
    if (value.ownsMoment !== completeOwnership) {
        ctx.addIssue({
            code: "custom",
            message: "ownsMoment requires a complete outcome and Agency presentation",
            path: ["ownsMoment"],
        });
    }
    if (value.presentation != null && value.presentation.role !== "AGENCY") {
        ctx.addIssue({
            code: "custom",
            message: "Studio safe-edit presentation must use the Agency projection",
            path: ["presentation", "role"],
        });
    }
});
//# sourceMappingURL=studio-safe-edit-presentation.js.map